import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThumbsDownIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ThumbsDown",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.79 2.62h1.07c1.18 0 2.14.96 2.14 2.14V17.6c0 1.18-.96 2.14-2.14 2.14h-1.07c-1.18 0-2.14-.96-2.14-2.14V4.76c0-1.18.96-2.14 2.14-2.14M19.3 4.76c.59 0 1.07.48 1.07 1.07V17.6l-1.96 8.8c-.11.48-.54.83-1.04.83h-1.28c-.59 0-1.07-.48-1.07-1.07V17.6H6.19c-1.18 0-2.14-.96-2.14-2.14a2.142 2.142 0 0 1 2.88-2.01h-.01v-.17a2.16 2.16 0 0 1-1.79-2.12C5.13 9.97 6.1 9 7.29 9c.13 0 .25.01.38.03h-.01v-.16a2.14 2.14 0 0 1 .71-4.12h10.94Zm0-2.14H8.36c-2.34.03-4.24 1.93-4.24 4.28 0 .45.07.88.2 1.29v-.03c-.79.77-1.27 1.85-1.27 3.03 0 .45.07.88.19 1.28v-.03c-.78.77-1.25 1.84-1.25 3.02 0 2.34 1.88 4.25 4.22 4.28h6.66v6.42c0 1.77 1.44 3.21 3.21 3.21h1.29c1.53 0 2.8-1.07 3.13-2.49v-.02l2.01-8.79c0-.07.01-.15.01-.24s0-.16-.01-.25 0-11.76 0-11.76c0-1.77-1.44-3.21-3.21-3.21Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.14 19.86H8.28c-1.89 0-3.43-1.54-3.43-3.43S6.39 13 8.28 13h2.29a1.14 1.14 0 1 1 0 2.28H8.28a1.14 1.14 0 1 0 0 2.28h6.86a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.57 15.29H8.28c-1.89 0-3.43-1.54-3.43-3.43 0-1.58 1.07-2.91 2.53-3.31-.16-.39-.24-.82-.24-1.26 0-1.89 1.54-3.43 3.43-3.43H14a1.14 1.14 0 1 1 0 2.28h-3.43a1.14 1.14 0 1 0 0 2.28 1.14 1.14 0 1 1 0 2.28H8.28a1.14 1.14 0 1 0 0 2.28h2.29a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.27 29c-1.45 0-2.8-.72-3.6-1.94-.8-1.21-.94-2.74-.37-4.07l1.34-3.13h-3.98a1.14 1.14 0 1 1 0-2.28h5.71c.38 0 .74.19.95.51s.25.73.1 1.08l-2.02 4.72c-.27.64-.21 1.34.17 1.92a2 2 0 0 0 1.08.82l3.83-6.7c.29-.52.45-1.11.45-1.7V9.58c0-1.89-1.54-3.43-3.43-3.43h-3.43a1.14 1.14 0 1 1 0-2.28h3.43c3.15 0 5.71 2.56 5.71 5.71v8.65c0 .99-.26 1.97-.75 2.83l-4.21 7.37c-.2.36-.58.58-.99.58ZM26.65 19.86c-.63 0-1.14-.51-1.14-1.14V5a1.14 1.14 0 1 1 2.28 0v13.71c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};